import { Component, EventEmitter, Input, Output } from '@angular/core';

import { WorkExperienceLevels } from '../../enums/enums';

export interface VacancyDetails {
  id: string;
  job_title: string;
  work_experience_level: number;
  language_skills: { skill_name: string }[];
  education_levels: { id: string; name: string }[];
}

@Component({
  selector: 'bwc-vacancy-apply',
  templateUrl: './vacancy-apply.component.html',
  styleUrls: ['./vacancy-apply.component.scss'],
})
export class VacancyApplyComponent {
  @Input() vacancyDetails: VacancyDetails | undefined;
  @Input() isActivated = false;
  @Input() alreadyApplied = false;
  @Input() showApplyCont = false;
  @Input() showApplyOFLCont = false;

  @Output() applyClicked = new EventEmitter<void>();

  readonly workLevels = WorkExperienceLevels;

  onApply(): void {
    this.applyClicked.emit();
  }
}
